export const ArticleTypeKeys = {
  INFO: 'INFO',
  WARNING: 'WARNING',
  INCIDENT: 'INCIDENT',
}

export const ArticleTypeValues = {
  [ArticleTypeKeys.INFO]: 'info',
  [ArticleTypeKeys.WARNING]: 'warning',
  [ArticleTypeKeys.INCIDENT]: 'incident',
}

export const ArticleShowBannerValue = 'banner'

export const DefaultArticleTypeValue = ArticleTypeValues[ArticleTypeKeys.INFO]

export const ArticleTypeLabelTranslationKeys = {
  [ArticleTypeKeys.INFO]: 'news.add.typeSection.information',
  [ArticleTypeKeys.WARNING]: 'news.add.typeSection.warning',
  [ArticleTypeKeys.INCIDENT]: 'news.add.typeSection.incident',
}

export const ArticleTypeBorder = {
  [ArticleTypeKeys.INFO]: 'info',
  [ArticleTypeKeys.WARNING]: 'warning',
  [ArticleTypeKeys.INCIDENT]: 'danger',
}

export const ArticleTypeIcon = {
  [ArticleTypeKeys.INFO]: 'midasAlert1',
  [ArticleTypeKeys.WARNING]: 'midasAlert2',
  [ArticleTypeKeys.INCIDENT]: 'midasSmileySad',
}

export const DefaultArticleTypeBorder = ArticleTypeBorder[ArticleTypeKeys.INFO]

export const ArticleScopeKeys = {
  GENERAL: 'GENERAL',
  PAYAPPLY: 'PAYAPPLY',
}

export const ArticleScopeValues = {
  [ArticleScopeKeys.GENERAL]: 'scope-general',
  [ArticleScopeKeys.PAYAPPLY]: 'scope-payapply',
}

export const DefaultArticleScopeValue =
  ArticleScopeValues[ArticleScopeKeys.GENERAL]

export const ArticleScopeLabelTranslationKeys = {
  [ArticleScopeKeys.GENERAL]: 'news.add.scopeSection.general',
  [ArticleScopeKeys.PAYAPPLY]: 'news.add.scopeSection.payapply',
}

export const ArticleScopePaths = {
  [ArticleScopeKeys.GENERAL]: '^/.*$',
  [ArticleScopeKeys.PAYAPPLY]: '^/apply.*$',
}

// exclusion of paths where incident notification banners should never be displayed
export const ArticleScopePathExclusions = ['^/news.*$']
